import React, { useEffect, useState } from "react";
import Layout from "../../components/layout";
import { FaArrowLeft, FaSearch, FaCalendarAlt } from "react-icons/fa";

import styles from "./JobworksPage.module.scss";
import { useNavigate } from "react-router-dom";
import { route } from "../../static/route";
import Select from "react-select";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  fetchItemsList,
  fetchJobworksListData,
  getItems,
  getJobworks,
  getParties,
  getTotalJobworks,
  fetchPartiesList,
  getIsJobworkModalOpen,
  getEditJobwork,
  setEditJobwork,
  getTotalAmount,
  getOrderParties,
  fetchOrderPartiesList,
} from "../../features/jobworks/jobworksSlice";
import Pagination from "../../components/pagination";
import { toast } from "react-toastify";
import { selectStyles, toastStyles } from "../../static/styles";
import { DELETE, GET, PUT } from "../../services/axios.service";
import { Controller, useForm } from "react-hook-form";
import JobworkList from "../../components/jobworks/JobworkList";
import JobworkFormModal from "../../components/jobworks/JobworkFormModal";
import { IFormInput, OptionsProps } from "../../types/jobworks";
import moment from "moment";

const JobworksPage = () => {
  const companyName = process.env.REACT_APP_COMPANY_NAME;

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const jobworks = useAppSelector(getJobworks);
  const totalJobworks = useAppSelector(getTotalJobworks);
  const totalAmount = useAppSelector(getTotalAmount);
  const items = useAppSelector(getItems);
  const parties = useAppSelector(getParties);
  const isJobworkModalOpen = useAppSelector(getIsJobworkModalOpen);
  const editJobwork = useAppSelector(getEditJobwork);
  const orderParties = useAppSelector(getOrderParties);

  const [itemOption, setItemOption] = useState<OptionsProps[]>([]);
  const [partyOption, setPartyOption] = useState<OptionsProps[]>([]);
  const [partyOption1, setPartyOption1] = useState<OptionsProps[]>([]);
  const [orderPartyOption, setOrderPartyOption] = useState<OptionsProps[]>([]);
  const [statusOption] = useState<OptionsProps[]>([
    {
      value: 0,
      label: "ચાલુ કામ",
    },
    {
      value: 1,
      label: "પૂરું થયેલું કામ",
    },
  ]);
  const [jobworkTypeOption] = useState<OptionsProps[]>([
    {
      value: 0,
      label: "બાંધવા આપેલ",
    },
    {
      value: 1,
      label: "ખોલવા આપેલ",
    },
  ]);
  const [typeOption] = useState<OptionsProps[]>([
    {
      value: 0,
      label: "કામ ના આધારે",
    },
    {
      value: 1,
      label: "પાર્ટી ના આધારે",
    },
  ]);

  interface FilterFormInput {
    name: string;
    fromDate: string;
    toDate: string;
    party_id: number;
    item_id: number;
    status: number;
    type: number;
    order_party_id: number;
  }

  interface ExportFormInput {
    fromDate: string;
    toDate: string;
    party_id: number;
    status: number;
    jobworkType: number;
    type: number;
    order_party_id: number;
  }

  const { handleSubmit, register, reset, getValues, control, setValue, watch } =
    useForm<FilterFormInput>();

  const {
    handleSubmit: handleSubmit1,
    register: register1,
    reset: reset1,
    control: control1,
    setValue: setValue1,
    watch: watch1,
  } = useForm<ExportFormInput>();

  const partyType = watch("type");
  const partyType1 = watch1("jobworkType");

  const [page, setPage] = useState<number>(1);
  const [pageSize] = useState<number>(50);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showFilter, setShowFilter] = useState(false);
  const [showExport, setShowExport] = useState(false);

  const hanldeGoToHome = () => {
    navigate(route.dashboard);
  };

  const paginate = (pageNumber: number) => {
    setPage(pageNumber);
  };

  const handleDeleteJobwork = async (id: number, password: string) => {
    try {
      await DELETE(`/v1/admin/jobworks/${id}`, {
        password: password,
      })
        .then(async (response: any) => {
          if (response.data.status === "success") {
            const pageNumber = jobworks.length > 1 ? page : page - 1;
            if (page === pageNumber) {
              fetchJobworksList(page, pageSize);
            } else {
              setPage(pageNumber);
            }

            toast.success(response.data.message, {
              ...(toastStyles as any),
            });
          } else {
            toast.error(response.data.message, {
              ...(toastStyles as any),
            });
          }
        })
        .catch((error: any) => {
          toast.error(error.data.message, {
            ...(toastStyles as any),
          });
        });
    } catch (error) {
      toast.error("કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.", {
        ...(toastStyles as any),
      });
    }
  };

  const handleOnFilterSubmit = async () => {
    fetchJobworksList(page, pageSize);
  };

  const handleOnExportSubmit = async (data: ExportFormInput) => {
    try {
      await GET(`/v1/admin/reports-jobworks`, {
        fromDate: data.fromDate,
        toDate: data.toDate,
        party_id: data.party_id,
        type: data.type,
        status: data.status,
        jobworkType: data.jobworkType,
      })
        .then(async (response: any) => {
          if (response.data.status === "success") {
            toast.success(response.data.message, {
              ...(toastStyles as any),
            });

            const downloadLink = response.data.data.download_link;
            try {
              const newWindow = window.open(downloadLink, "_blank");
              if (
                !newWindow ||
                newWindow.closed ||
                typeof newWindow.closed == "undefined"
              ) {
                throw new Error("પોપ્અપ બ્લોક કરેલ છે.");
              }
            } catch (e) {
              window.location.href = downloadLink;
            }
          } else {
            toast.error(response.data.message, {
              ...(toastStyles as any),
            });
          }
        })
        .catch((error: any) => {
          toast.error(error.data.message, {
            ...(toastStyles as any),
          });
        });
    } catch (error) {
      toast.error("કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.", {
        ...(toastStyles as any),
      });
    }
  };

  const handleClearFilter = () => {
    reset();
    fetchJobworksList(page, pageSize);
  };

  const handleClearExport = () => {
    reset1();
  };

  const fetchJobworksList = async (page: number, size: number) => {
    const data = getValues();

    setIsLoading(true);

    dispatch(
      fetchJobworksListData({
        page: page,
        size: size,
        search: data?.name || null,
        fromDate: data?.fromDate || null,
        toDate: data?.toDate || null,
        party_id: data?.party_id || null,
        item_id: data?.item_id || null,
        status: data?.status || data?.status === 0 ? data?.status : null,
        type: data?.type || data?.type === 0 ? data?.type : null,
      })
    ).then(() => {
      setIsLoading(false);
    });
  };

  const handleSaveJobwork = async (data: IFormInput) => {
    try {
      if (editJobwork) {
        await PUT(`/v1/admin/jobworks/${editJobwork.id}`, {
          rate: data.rate,
          i_weight: data.i_weight,
          i_delivered_weight: data.i_delivered_weight,
          t_weight: data.t_weight,
          status: data.status,
          type: editJobwork.type,
          created_at: moment(data.created_at).format("YYYY-MM-DD H:mm:ss"),
        })
          .then(async (response: any) => {
            if (response.data.status === "success") {
              await dispatch(setEditJobwork(null));

              fetchJobworksList(page, pageSize);

              toast.success(response.data.message, {
                ...(toastStyles as any),
              });
            } else {
              toast.error(response.data.message, {
                ...(toastStyles as any),
              });
            }
          })
          .catch((error: any) => {
            toast.error(error.data.message, {
              ...(toastStyles as any),
            });
          });
      }
    } catch (error) {
      toast.error("કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.", {
        ...(toastStyles as any),
      });
    }
  };

  useEffect(() => {
    fetchJobworksList(page, pageSize);
  }, [page]);

  useEffect(() => {
    const options =
      items?.map((item) => ({ value: item.id, label: item.name })) ?? [];
    setItemOption(options);
  }, [items]);

  useEffect(() => {
    const type = partyType >= 0 ? partyType + 1 : 0;

    const options =
      parties
        ?.filter((party) =>
          type > 0 ? party.type === type || party.type === 3 : true
        )
        ?.map((party) => ({
          value: party.id,
          label: party.name + (party.phone ? " (" + party.phone + ")" : ""),
        })) ?? [];
    setPartyOption(options);
  }, [parties, partyType]);

  useEffect(() => {
    const type = partyType1 >= 0 ? partyType1 + 1 : 0;

    const options =
      parties
        ?.filter((party) =>
          type > 0 ? party.type === type || party.type === 3 : true
        )
        ?.map((party) => ({
          value: party.id,
          label: party.name + (party.phone ? " (" + party.phone + ")" : ""),
        })) ?? [];
    setPartyOption1(options);
  }, [parties, partyType1]);

  useEffect(() => {
    const options =
      orderParties?.map((party) => ({
        value: party.id,
        label:
          party.firm_name +
          (party.name ? " - " + party.name : "") +
          (party.phone ? " (" + party.phone + ")" : ""),
      })) ?? [];
    setOrderPartyOption(options);
  }, [orderParties]);

  useEffect(() => {
    dispatch(fetchItemsList());
    dispatch(fetchPartiesList());
    dispatch(fetchOrderPartiesList());
  }, []);

  return (
    <Layout>
      <div className={styles.JobworksPage}>
        <div className="logoSection">
          <h1
            onClick={hanldeGoToHome}
            className="text-4xl font-bold text-white lg:text-2xl cursor-pointer lg:w-fit"
          >
            {companyName}
          </h1>

          <hr className="w-[180px] border-white border-[4px] rounded-[4px] mx-auto mt-4 lg:mx-0 lg:w-24 lg:border-[2px] lg:mt-2" />
        </div>

        <div className="pageTitleSection">
          <FaArrowLeft
            onClick={hanldeGoToHome}
            className="lg:hidden absolute top-5 left-5 text-3xl text-white border-2 border-white p-1 rounded-full"
          />

          <h1 className="text-5xl mt-6 lg:mt-0 font-bold text-white lg:text-2xl lg:text-primary-1">
            બાંધવા/ખોલવા ની વિગતો
          </h1>
        </div>

        <div className="mt-[60px] px-10 py-5">
          <div className="flex justify-between gap-4 items-center mb-4">
            <p className="text-primary-1 font-bold mt-auto">
              ટોટલ અમાઉન્ટ: {totalAmount.toFixed(2) || 0.0}
            </p>

            <div className="grid lg:flex gap-4">
              <button
                className="p-2 rounded-md flex items-center bg-gradient-to-r from-primary-1 to-primary-2 text-white transition-colors duration-300"
                onClick={() => {
                  if (!showExport === true) setShowFilter(false);
                  setShowExport(!showExport);
                }}
              >
                <FaSearch className="mr-2" />{" "}
                {showExport ? "રિપોર્ટ છુપાવો" : "રિપોર્ટ બતાવો"}
              </button>

              <button
                className="p-2 rounded-md flex items-center bg-gradient-to-r from-primary-1 to-primary-2 text-white transition-colors duration-300"
                onClick={() => {
                  if (!showFilter === true) setShowExport(false);
                  setShowFilter(!showFilter);
                }}
              >
                <FaSearch className="mr-2" />{" "}
                {showFilter ? "ફિલ્ટર છુપાવો" : "ફિલ્ટર બતાવો"}
              </button>
            </div>
          </div>

          {showFilter && (
            <form onSubmit={handleSubmit(handleOnFilterSubmit)}>
              <div className="mb-4 bg-white shadow rounded p-4">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div className="flex items-center bg-gradient-to-r from-primary-1 to-primary-2 rounded pr-[2px] h-[44px]">
                    <FaCalendarAlt className="text-white mx-2" />
                    <input
                      className="bg-white text-primary-1 placeholder:text-primary-2 font-semibold text-xl focus:outline-none p-2 rounded flex-grow h-[40px]"
                      type="date"
                      {...register("fromDate")}
                      placeholder="From Date"
                    />
                  </div>

                  <div className="flex items-center bg-gradient-to-r from-primary-1 to-primary-2 rounded pr-[2px] h-[44px]">
                    <FaCalendarAlt className="text-white mx-2" />
                    <input
                      className="bg-white text-primary-1  placeholder:text-primary-2 font-semibold text-xl focus:outline-none p-2 rounded flex-grow h-[40px]"
                      type="date"
                      {...register("toDate")}
                      placeholder="To Date"
                    />
                  </div>

                  <div className="flex items-center bg-gradient-to-r from-primary-1 to-primary-2 rounded p-[2px] h-[44px]">
                    <input
                      {...register("name")}
                      className="text-primary-1 px-3 py-1 font-semibold text-xl placeholder:text-primary-2 w-full h-full rounded focus:outline-none"
                      placeholder="બાંધવા/ખોલવા ની ID દ્વારા શોધો"
                    />
                  </div>

                  <div className="bg-gradient-to-r from-primary-1 to-primary-2 h-16 lg:h-12 w-full relative rounded">
                    <Controller
                      {...register("type")}
                      control={control}
                      render={({ field }) => (
                        <Select
                          isClearable
                          {...field}
                          value={
                            jobworkTypeOption.find(
                              (val) => val.value === field.value
                            ) || null
                          }
                          className="text-primary-1 p-0 font-semibold text-xl placeholder:text-primary-2 absolute top-[2px] left-[2px] w-[calc(100%-4px)] h-[calc(100%-4px)] rounded"
                          styles={selectStyles}
                          placeholder={"ટાઈપ સિલેક્ટ કરો"}
                          options={jobworkTypeOption}
                          onChange={(val: any) => setValue("type", val?.value)}
                        />
                      )}
                    />
                  </div>

                  <div className="bg-gradient-to-r from-primary-1 to-primary-2 h-16 lg:h-12 w-full relative rounded">
                    <Controller
                      {...register("party_id")}
                      control={control}
                      render={({ field }) => (
                        <Select
                          isClearable
                          {...field}
                          value={
                            partyOption.find(
                              (val) => val.value === field.value
                            ) || null
                          }
                          className="text-primary-1 p-0 font-semibold text-xl placeholder:text-primary-2 absolute top-[2px] left-[2px] w-[calc(100%-4px)] h-[calc(100%-4px)] rounded"
                          styles={selectStyles}
                          placeholder={"પાર્ટી નું નામ સિલેક્ટ કરો"}
                          options={partyOption}
                          onChange={(val: any) =>
                            setValue("party_id", val?.value)
                          }
                        />
                      )}
                    />
                  </div>

                  <div className="bg-gradient-to-r from-primary-1 to-primary-2 h-16 lg:h-12 w-full relative rounded">
                    <Controller
                      {...register("order_party_id")}
                      control={control}
                      render={({ field }) => (
                        <Select
                          isClearable
                          {...field}
                          value={
                            orderPartyOption.find(
                              (val) => val.value === field.value
                            ) || null
                          }
                          className="text-primary-1 p-0 font-semibold text-xl placeholder:text-primary-2 absolute top-[2px] left-[2px] w-[calc(100%-4px)] h-[calc(100%-4px)] rounded"
                          styles={selectStyles}
                          placeholder={"ઓર્ડર પાર્ટી નું નામ સિલેક્ટ કરો"}
                          options={orderPartyOption}
                          onChange={(val: any) =>
                            setValue("order_party_id", val?.value)
                          }
                        />
                      )}
                    />
                  </div>

                  <div className="bg-gradient-to-r from-primary-1 to-primary-2 h-16 lg:h-12 w-full relative rounded">
                    <Controller
                      {...register("item_id")}
                      control={control}
                      render={({ field }) => (
                        <Select
                          isClearable
                          {...field}
                          value={
                            itemOption.find(
                              (val) => val.value === field.value
                            ) || null
                          }
                          className="text-primary-1 p-0 font-semibold text-xl placeholder:text-primary-2 absolute top-[2px] left-[2px] w-[calc(100%-4px)] h-[calc(100%-4px)] rounded"
                          styles={selectStyles}
                          placeholder={"આઈટમ નું નામ સિલેક્ટ કરો"}
                          options={itemOption}
                          onChange={(val: any) =>
                            setValue("item_id", val?.value)
                          }
                        />
                      )}
                    />
                  </div>

                  <div className="bg-gradient-to-r from-primary-1 to-primary-2 h-16 lg:h-12 w-full relative rounded">
                    <Controller
                      {...register("status")}
                      control={control}
                      render={({ field }) => (
                        <Select
                          isClearable
                          {...field}
                          value={
                            statusOption.find(
                              (val) => val.value === field.value
                            ) || null
                          }
                          className="text-primary-1 p-0 font-semibold text-xl placeholder:text-primary-2 absolute top-[2px] left-[2px] w-[calc(100%-4px)] h-[calc(100%-4px)] rounded"
                          styles={selectStyles}
                          placeholder={"સ્ટેટ્સ નું નામ સિલેક્ટ કરો"}
                          options={statusOption}
                          onChange={(val: any) =>
                            setValue("status", val?.value)
                          }
                        />
                      )}
                    />
                  </div>
                </div>
                <div className="flex gap-4 justify-end mt-4">
                  <button
                    onClick={handleClearFilter}
                    type="button"
                    className="bg-primary-1 hover:bg-primary-2 text-white px-4 py-2 rounded-md transition duration-300 ease-in-out"
                  >
                    હટાઓ
                  </button>

                  <button
                    type="submit"
                    className="bg-primary-1 hover:bg-primary-2 text-white px-4 py-2 rounded-md transition duration-300 ease-in-out"
                  >
                    ફિલ્ટર લાગુ કરો
                  </button>
                </div>
              </div>
            </form>
          )}

          {showExport && (
            <form onSubmit={handleSubmit1(handleOnExportSubmit)}>
              <div className="mb-4 bg-white shadow rounded p-4">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div className="flex items-center bg-gradient-to-r from-primary-1 to-primary-2 rounded pr-[2px] h-[44px]">
                    <FaCalendarAlt className="text-white mx-2" />
                    <input
                      className="bg-white text-primary-1 placeholder:text-primary-2 font-semibold text-xl focus:outline-none p-2 rounded flex-grow h-[40px]"
                      type="date"
                      {...register1("fromDate")}
                      placeholder="From Date"
                    />
                  </div>

                  <div className="flex items-center bg-gradient-to-r from-primary-1 to-primary-2 rounded pr-[2px] h-[44px]">
                    <FaCalendarAlt className="text-white mx-2" />
                    <input
                      className="bg-white text-primary-1  placeholder:text-primary-2 font-semibold text-xl focus:outline-none p-2 rounded flex-grow h-[40px]"
                      type="date"
                      {...register1("toDate")}
                      placeholder="To Date"
                    />
                  </div>

                  <div className="bg-gradient-to-r from-primary-1 to-primary-2 h-16 lg:h-12 w-full relative rounded">
                    <Controller
                      {...register1("jobworkType")}
                      control={control1}
                      render={({ field }) => (
                        <Select
                          isClearable
                          {...field}
                          value={
                            jobworkTypeOption.find(
                              (val) => val.value === field.value
                            ) || null
                          }
                          className="text-primary-1 p-0 font-semibold text-xl placeholder:text-primary-2 absolute top-[2px] left-[2px] w-[calc(100%-4px)] h-[calc(100%-4px)] rounded"
                          styles={selectStyles}
                          placeholder={"ટાઈપ સિલેક્ટ કરો"}
                          options={jobworkTypeOption}
                          onChange={(val: any) =>
                            setValue1("jobworkType", val?.value)
                          }
                        />
                      )}
                    />
                  </div>

                  <div className="bg-gradient-to-r from-primary-1 to-primary-2 h-16 lg:h-11 w-full relative rounded">
                    <Controller
                      {...register1("party_id")}
                      control={control1}
                      render={({ field }) => (
                        <Select
                          isClearable
                          {...field}
                          value={
                            partyOption1.find(
                              (val) => val.value === field.value
                            ) || null
                          }
                          className="text-primary-1 p-0 font-semibold text-xl placeholder:text-primary-2 absolute top-[2px] left-[2px] w-[calc(100%-4px)] h-[calc(100%-4px)] rounded"
                          styles={selectStyles}
                          placeholder={"પાર્ટી નું નામ સિલેક્ટ કરો"}
                          options={partyOption1}
                          onChange={(val: any) =>
                            setValue1("party_id", val?.value)
                          }
                        />
                      )}
                    />
                  </div>

                  <div className="bg-gradient-to-r from-primary-1 to-primary-2 h-16 lg:h-11 w-full relative rounded">
                    <Controller
                      {...register1("order_party_id")}
                      control={control1}
                      render={({ field }) => (
                        <Select
                          isClearable
                          {...field}
                          value={
                            orderPartyOption.find(
                              (val) => val.value === field.value
                            ) || null
                          }
                          className="text-primary-1 p-0 font-semibold text-xl placeholder:text-primary-2 absolute top-[2px] left-[2px] w-[calc(100%-4px)] h-[calc(100%-4px)] rounded"
                          styles={selectStyles}
                          placeholder={"ઓર્ડર પાર્ટી નું નામ સિલેક્ટ કરો"}
                          options={orderPartyOption}
                          onChange={(val: any) =>
                            setValue1("order_party_id", val?.value)
                          }
                        />
                      )}
                    />
                  </div>

                  <div className="bg-gradient-to-r from-primary-1 to-primary-2 h-16 lg:h-11 w-full relative rounded">
                    <Controller
                      {...register1("status")}
                      control={control1}
                      render={({ field }) => (
                        <Select
                          isClearable
                          {...field}
                          value={
                            statusOption.find(
                              (val) => val.value === field.value
                            ) || null
                          }
                          className="text-primary-1 p-0 font-semibold text-xl placeholder:text-primary-2 absolute top-[2px] left-[2px] w-[calc(100%-4px)] h-[calc(100%-4px)] rounded"
                          styles={selectStyles}
                          placeholder={"સ્ટેટ્સ નું નામ સિલેક્ટ કરો"}
                          options={statusOption}
                          onChange={(val: any) =>
                            setValue1("status", val?.value)
                          }
                        />
                      )}
                    />
                  </div>

                  <div className="bg-gradient-to-r from-primary-1 to-primary-2 h-16 lg:h-11 w-full relative rounded">
                    <Controller
                      {...register1("type")}
                      control={control1}
                      defaultValue={0}
                      render={({ field }) => (
                        <Select
                          isClearable
                          {...field}
                          value={
                            typeOption.find(
                              (val) => val.value === field.value
                            ) || null
                          }
                          className="text-primary-1 p-0 font-semibold text-xl placeholder:text-primary-2 absolute top-[2px] left-[2px] w-[calc(100%-4px)] h-[calc(100%-4px)] rounded"
                          styles={selectStyles}
                          placeholder={"ટાઈપ સિલેક્ટ કરો"}
                          options={typeOption}
                          onChange={(val: any) => setValue1("type", val?.value)}
                        />
                      )}
                    />
                  </div>
                </div>
                <div className="flex gap-4 justify-end mt-4">
                  <button
                    onClick={handleClearExport}
                    type="button"
                    className="bg-primary-1 hover:bg-primary-2 text-white px-4 py-2 rounded-md transition duration-300 ease-in-out"
                  >
                    હટાઓ
                  </button>

                  <button
                    type="submit"
                    className="bg-primary-1 hover:bg-primary-2 text-white px-4 py-2 rounded-md transition duration-300 ease-in-out"
                  >
                    રિપોર્ટ બનાવો
                  </button>
                </div>
              </div>
            </form>
          )}

          <JobworkList
            jobworks={jobworks}
            pageNumber={page}
            pageSize={pageSize}
            isLoading={isLoading}
            handleDeleteJobwork={handleDeleteJobwork}
          />

          <Pagination
            itemsPerPage={pageSize}
            totalItems={totalJobworks}
            paginate={paginate}
            currentPage={page}
          />

          {isJobworkModalOpen === true && (
            <JobworkFormModal handleSaveJobwork={handleSaveJobwork} />
          )}
        </div>
      </div>
    </Layout>
  );
};
export default JobworksPage;
